import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import { formatDate } from "../../../functions/dateTime/formatDate";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import Modal from "../../../components/portal/Modal";
import { checkValue } from "../../../functions/checkValue";
import successIcon from "../../../assets/icons/successIcon.svg";

export default function UserViewDetailsDialog({ viewDetails, successMsg }) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">{successMsg}</p>
      <div className={`px-2 overflow-auto 2xs:max-2xl:h-[65vh]`}>
        <div className="view-dialog-content-wrap">
          <DetailRow title="User Name" value={viewDetails.fullName} />
          <DetailRow title="Email" value={viewDetails.email} />
          <DetailRow title="Phone Number" value={viewDetails.mobileNumber} />
          <DetailRow
            title="Alternate Phone"
            value={checkValue(viewDetails.altPhoneNumber)}
          />
          <DetailRow title="Gender" value={viewDetails.gender.name} />
          <DetailRow
            title="Date of birth"
            value={
              viewDetails.dob ? formatDate(viewDetails.dob) : "Not Available"
            }
          />
          <DetailRow title="Salary" value={`${viewDetails.salary} /-`} />
          <DetailRow
            title="Bike Registration No."
            value={checkValue(viewDetails.bikeRegNumber)}
          />
          <DetailRow
            title="Aaadhar Card No."
            value={viewDetails.aadharCardNumber}
          />
          <DetailRow title="Pan Card No." value={viewDetails.panCardNumber} />
          {viewDetails.dateOfJoining && (
            <DetailRow
              title="Date of Joining"
              value={formatDate(viewDetails.dateOfJoining)}
            />
          )}
          <DetailRow
            title="Account No."
            value={checkValue(viewDetails.accountNumber)}
          />
          <DetailRow title="IFSC Code" value={checkValue(viewDetails.ifsc)} />
          <DetailRow
            title="Branch Name"
            value={checkValue(viewDetails.bankName?.name)}
          />
          <DetailRow
            title="Branch Branch"
            value={checkValue(viewDetails.bankBranch)}
          />
          <DetailRow
            title="JBCC Supervisor"
            value={viewDetails.jbccSupervisor.fullName}
          />
          <DetailRow
            title="JN Supervisor"
            value={viewDetails.jnSupervisor.fullName}
          />
          <DetailRow
            title="JBCC Admin"
            value={viewDetails.jbccAdmin.fullName}
          />
          <DetailRow title="JN Admin" value={viewDetails.jnAdmin.fullName} />
        </div>
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/user/all")}
        />
      </div>
    </Modal>
  );
}
